module.exports = __webpack_public_path__ + "img/newchris-22.b92e0a2c.jpg";